// extracted by mini-css-extract-plugin
module.exports = {"default":"GridCardComponent_default__2luzA"};